(() => {
  'use strict';
  const tr = s => (globalThis.mcT && globalThis.mcT[s]) || s, trf = (s, v) => tr(s).replace(/\{(\w+)\}/g, (_, k) => v[k]); // i18n: locales via snippets/meucompra-i18n-js.liquid
  const $ = selector => document.querySelector(selector);
  const $$ = selector => [...document.querySelectorAll(selector)];
  const root = (document.body.dataset.root || '/').replace(/\/?$/, '/');
  const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  // Links stay inside the shop; images may also use Shopify's media CDN.
  function safeUrl(value, image = false) {
    if (typeof value !== 'string' || !value.trim()) return '';
    try {
      const url = new URL(value, location.origin);
      if (url.username || url.password || !['http:', 'https:'].includes(url.protocol)) return '';
      if (url.origin === location.origin) return url.href;
      return image && url.protocol === 'https:' && url.hostname === 'cdn.shopify.com' ? url.href : '';
    } catch { return ''; }
  }
  function money(value, currency = document.body.dataset.currency || 'BRL') {
    try { return new Intl.NumberFormat('pt-BR', { style: 'currency', currency }).format(value / 100); }
    catch { return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value / 100); }
  }
  const normalize = value => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const setText = (selector, value) => { const el = $(selector); if (el) el.textContent = value; };
  let favorites = [];
  try {
    const parsed = JSON.parse(localStorage.getItem('meucompra-favorites-v1') || '[]');
    if (Array.isArray(parsed)) favorites = [...new Set(parsed.filter(value => typeof value === 'string' && /^[a-z0-9-]{1,255}$/.test(value)))].slice(0, 1000);
  } catch {}
  const fullCartPage = location.pathname?.replace(/\/$/, '') === root + 'cart';
  let toastTimer, lastFocus, currentCart;
  let cartBusy = false, productBusy = false, cartReady = false, cartReadVersion = 0;
  let cartNeedsRefresh = false, cartCloseRequested = false;
  function toast(message) {
    const el = $('#toast'); if (!el) return;
    el.textContent = message; el.classList.add('visible'); clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('visible'), 3500);
  }
  async function request(endpoint, body) {
    let response;
    try {
      response = await fetch(root + endpoint, {
        method: body ? 'POST' : 'GET', credentials: 'same-origin',
        headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
        body: body ? JSON.stringify(body) : undefined,
        signal: AbortSignal.timeout(20000)
      });
    } catch { throw new Error(body ? tr('Não foi possível confirmar a alteração. Confira sua sacola antes de tentar novamente.') : tr('Não foi possível carregar sua sacola. Tente abrir novamente.')); }
    let data;
    try { data = await response.json(); } catch { throw new Error(tr('Não foi possível confirmar a resposta da loja. Confira sua sacola antes de tentar novamente.')); }
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : tr('Não foi possível atualizar a sacola.'));
    return data;
  }
  function validateCart(cart) {
    const integer = value => Number.isSafeInteger(value) && value >= 0;
    if (!cart || !Array.isArray(cart.items) || !integer(cart.item_count) || !integer(cart.total_price) || typeof cart.currency !== 'string' ||
      !cart.items.every(item => item && typeof item.key === 'string' && integer(item.quantity) && integer(item.final_line_price))) {
      throw new Error(tr('Não foi possível confirmar os valores da sacola. Tente abrir novamente.'));
    }
    return cart;
  }
  function syncCartControls() {
    if ($('#checkout')) $('#checkout').disabled = cartBusy || !cartReady || !currentCart?.item_count;
    $$('#cart-items button').forEach(button => {
      const item = currentCart?.items.find(line => line.key === (button.dataset.cartKey || button.dataset.removeKey));
      button.disabled = cartBusy || !cartReady || (button.dataset.cartChange === '1' && item?.quantity >= 20);
    });
  }
  function cartSignature(cart) { return JSON.stringify([cart.total_price, cart.items.map(item => [item.key, item.quantity, item.final_line_price])]); }
  function renderCart(data) {
    const cart = validateCart(data);
    if (fullCartPage && currentCart && cartSignature(currentCart) !== cartSignature(cart)) cartNeedsRefresh = true;
    currentCart = cart; cartReady = true;
    $$('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    setText('#cart-total', money(cart.total_price, cart.currency));
    const feeData = document.body.dataset.shippingFee, free = (document.body.dataset.freeShipping || '').split(',').filter(Boolean);
    const shipped = cart.items.filter(item => item.requires_shipping === true), estimate = $('#cart-estimate');
    if (estimate) {
      const fee = shipped.length && shipped.some(item => !free.includes(item.handle)) ? Number(feeData) : 0;
      estimate.hidden = !cart.item_count || feeData === '' || feeData == null || !Number.isFinite(fee);
      setText('#cart-shipping', !shipped.length ? tr('Sem frete') : fee ? money(fee, cart.currency) : tr('Grátis'));
      setText('#cart-estimated-total', money(cart.total_price + (fee || 0), cart.currency));
    }
    const note = $('#cart-delivery-note');
    if (note && cart.item_count) note.textContent = (shipped.length ? note.dataset.physical : note.dataset.digital) || note.textContent;
    $('#cart-items').innerHTML = cart.items.length ? cart.items.map(item => {
      const image = safeUrl(item.image, true), href = safeUrl(item.url) || root;
      return `<article class="cart-item">${image ? `<img class="product-photo" src="${escape(image)}" alt="${escape(item.product_title)}" width="82" height="82">` : '<span></span>'}<div><a href="${escape(href)}"><h3>${escape(item.product_title)}</h3></a><p>${escape(item.variant_title === 'Default Title' ? '' : item.variant_title || '')}</p><p>${money(item.final_line_price, cart.currency)}</p><div class="cart-item-actions"><div class="quantity"><button type="button" data-cart-key="${escape(item.key)}" data-cart-change="-1" aria-label="${escape(trf('Diminuir quantidade de {item}', { item: item.title }))}">−</button><span>${item.quantity}</span><button type="button" data-cart-key="${escape(item.key)}" data-cart-change="1" aria-label="${escape(trf('Aumentar quantidade de {item}', { item: item.title }))}" ${item.quantity >= 20 ? 'disabled' : ''}>+</button></div><button type="button" class="remove-item" data-remove-key="${escape(item.key)}">${escape(tr('Remover'))}</button></div></div></article>`;
    }).join('') : `<div class="empty-state"><h3>${escape(tr('Sua sacola está vazia.'))}</h3><p>${escape(tr('Escolha seus próximos achados.'))}</p><a class="button secondary" href="${escape(root)}">${escape(tr('Explorar a loja'))}</a></div>`;
    renderExtras(cart);
    syncCartControls();
  }
  // Optional extras for infoproducts: unchecked boxes, visible prices, offered once, nothing added without a click.
  let extrasConfig = null;
  try { extrasConfig = JSON.parse($('#cart-extras-config')?.textContent || 'null'); } catch { extrasConfig = null; }
  function renderExtras(cart) {
    const box = $('#cart-extras'); if (!box) return;
    const handles = cart.items.map(item => item.handle);
    const show = extrasConfig && handles.some(handle => extrasConfig.triggers.includes(handle)) && !(extrasConfig.combo && handles.includes(extrasConfig.combo.handle));
    const extras = show ? extrasConfig.extras.filter(extra => !handles.includes(extra.handle) && Number.isSafeInteger(extra.variantId)) : [];
    const certificate = show && extrasConfig.certificate && !handles.includes(extrasConfig.certificate.handle) ? extrasConfig.certificate : null;
    const combo = show && extrasConfig.combo && Number.isSafeInteger(extrasConfig.combo.variantId) ? extrasConfig.combo : null;
    box.hidden = !extras.length && !certificate && !combo;
    if (box.hidden) { box.innerHTML = ''; return; }
    const quiz = safeUrl(certificate?.quiz || '');
    const list = extras.length || (certificate && quiz) ? `<form data-cart-extras-form><ul class="cart-extras-list">${extras.map(extra => `<li><label><input type="checkbox" value="${extra.variantId}"> <span>${escape(extra.title)}</span> <strong>${money(extra.price, cart.currency)}</strong></label></li>`).join('')}${certificate && quiz ? `<li class="cart-extras-quiz"><span>${escape(certificate.title)} <strong>${money(certificate.price, cart.currency)}</strong> · à parte, depois do teste</span><a class="text-link" href="${escape(quiz)}">Fazer o teste grátis primeiro</a></li>` : ''}</ul>${extras.length ? '<button class="button secondary" type="submit" data-cart-extras-submit disabled>Adicionar os selecionados</button>' : ''}</form>` : '';
    // The guide is already in the bag, so the combo is a swap (guide and kits out, combo in), never a second guide.
    const swap = combo ? `<div class="cart-extras-combo"><p>Prefere os 3? <strong>Combo guia + 2 kits: ${money(combo.price, cart.currency)}</strong> (separado sairia ${money(combo.separate, cart.currency)}). O combo já inclui o guia: troque o guia pelo combo e não pague duas vezes. O certificado é à parte.</p><button class="button secondary" type="button" data-combo-swap>Trocar o guia pelo combo</button></div>` : '';
    box.innerHTML = `<h3>Extras opcionais</h3><p class="cart-extras-note">Nenhum é necessário para usar o guia.</p>${list}${swap}`;
  }
  // Swap: add the combo first (if that fails nothing was removed), then take out the guide and kits it already includes.
  async function swapCombo() {
    const combo = extrasConfig?.combo;
    if (!combo || cartBusy || !Number.isSafeInteger(combo.variantId)) return;
    cartBusy = true; ++cartReadVersion; syncCartControls(); syncProductControls();
    try {
      const cart = validateCart(await request('cart.js'));
      if (!cart.items.some(item => item.handle === combo.handle)) await request('cart/add.js', { items: [{ id: combo.variantId, quantity: 1 }] });
      const updates = {};
      for (const item of cart.items) if ((combo.parts || []).includes(item.handle)) updates[item.key] = 0;
      if (Object.keys(updates).length) await request('cart/update.js', { updates });
      setText('#checkout-message', 'Pronto: o guia saiu e o combo entrou na sacola.');
    } catch (error) { setText('#checkout-message', error.message); }
    finally {
      try { renderCart(await request('cart.js')); } catch { cartReady = false; }
      cartBusy = false; syncCartControls(); syncProductControls();
      if (fullCartPage) location.reload();
    }
  }
  document.addEventListener('change', event => {
    const form = event.target.closest?.('[data-cart-extras-form]'); if (!form) return;
    const submit = form.querySelector('[data-cart-extras-submit]'); if (submit) submit.disabled = !form.querySelector('input[type=checkbox]:checked');
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest?.('[data-cart-extras-form]'); if (!form) return;
    event.preventDefault();
    const ids = [...form.querySelectorAll('input[type=checkbox]:checked')].map(input => Number(input.value)).filter(Number.isSafeInteger);
    if (!ids.length || cartBusy) return;
    cartBusy = true; ++cartReadVersion; syncCartControls(); syncProductControls();
    try { await request('cart/add.js', { items: ids.map(id => ({ id, quantity: 1 })) }); }
    catch (error) { setText('#checkout-message', error.message); }
    finally {
      try { renderCart(await request('cart.js')); } catch { cartReady = false; }
      cartBusy = false; syncCartControls(); syncProductControls();
      if (fullCartPage) location.reload();
    }
  });
  async function openCart() {
    const dialog = $('#cart'); if (!dialog) return;
    if (!dialog.open) { lastFocus = document.activeElement; dialog.showModal(); }
    if (cartBusy) return;
    const version = ++cartReadVersion;
    cartReady = false; syncCartControls(); setText('#checkout-message', '');
    try {
      const cart = await request('cart.js');
      if (version === cartReadVersion && !cartBusy) renderCart(cart);
    } catch (error) {
      if (version !== cartReadVersion || cartBusy) return;
      cartReady = false; syncCartControls(); setText('#checkout-message', error.message);
      setText('#cart-items', tr('Não foi possível carregar sua sacola. Feche e abra novamente para tentar outra vez.'));
    }
  }
  function closeCart() {
    if (fullCartPage && cartBusy) { cartCloseRequested = true; return; }
    cartCloseRequested = false; $('#cart').close(); lastFocus?.focus();
  }
  function refreshFullCart() { if (fullCartPage && cartNeedsRefresh) { cartNeedsRefresh = false; location.reload(); } }
  function syncProductControls() {
    const option = $('#variant-select')?.selectedOptions[0];
    const available = option?.dataset.available === 'true';
    const disabled = productBusy || cartBusy || !available;
    if ($('#add-to-cart')) {
      $('#add-to-cart').disabled = disabled;
      $('#add-to-cart').textContent = productBusy ? tr('Adicionando…') : available ? tr('Adicionar à sacola') : tr('Indisponível');
    }
    $$('[data-mobile-add]').forEach(button => { button.disabled = disabled; button.textContent = productBusy ? tr('Adicionando…') : available ? tr('Adicionar à sacola') : tr('Indisponível'); });
    if ($('#variant-select')) $('#variant-select').disabled = productBusy;
    if ($('#quantity')) $('#quantity').disabled = productBusy;
    $$('[data-quantity]').forEach(button => button.disabled = productBusy);
  }
  function variantChanged() {
    const select = $('#variant-select'), option = select?.selectedOptions[0]; if (!option) return;
    const title = option.dataset.title || option.textContent.split(' — ')[0];
    setText('#variant-price', option.dataset.price);
    setText('#mobile-variant-price', option.dataset.price);
    setText('#mobile-variant-title', title === 'Default Title' ? tr('Modelo único') : title);
    const compare = $('#variant-compare');
    if (compare) { compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare; }
    const availability = $('#variant-availability');
    if (availability) { availability.textContent = option.dataset.available === 'true' ? tr('Disponível para compra') : tr('Indisponível no momento'); availability.dataset.available = option.dataset.available; }
    setText('#image-caption', trf('Foto da opção: {title}', { title: title === 'Default Title' ? tr('Modelo único') : title }));
    setText('#selected-option', title === 'Default Title' ? tr('Modelo único') : title);
    setText('#mobile-offer-price', option.dataset.price);
    updateEstimate();
    const img = $('#detail-photo'), source = safeUrl(option.dataset.image, true);
    if (img && source) { img.src = source; img.removeAttribute('srcset'); }
    syncProductControls();
    const url = new URL(location.href); url.searchParams.set('variant', select.value); history.replaceState({}, '', url);
  }
  // Estimated total on the product page: selected price x quantity + the fixed fee shown in the summary.
  function updateEstimate() {
    const out = $('#estimated-total'), fee = $('#cost-summary')?.dataset.fee, option = $('#variant-select')?.selectedOptions[0];
    const price = Number(option?.dataset.priceCents), quantity = Number($('#quantity')?.value) || 1;
    if (!out || fee === '' || fee == null || !Number.isFinite(price)) return;
    out.textContent = money(price * Math.max(1, Math.min(20, quantity)) + Number(fee));
  }
  $('#variant-select')?.addEventListener('change', variantChanged);
  $('#quantity')?.addEventListener('input', updateEstimate);
  $('#product-form')?.addEventListener('submit', async event => {
    event.preventDefault();
    if (productBusy || cartBusy || $('#add-to-cart').disabled) return;
    const select = $('#variant-select'), id = select.value, quantity = Number($('#quantity').value);
    if (select.selectedOptions[0]?.dataset.available !== 'true' || !/^\d+$/.test(id)) { setText('#product-message', tr('Escolha um modelo disponível.')); return; }
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 20) { setText('#product-message', tr('Escolha uma quantidade entre 1 e 20.')); return; }
    productBusy = true; cartBusy = true; cartReady = false; ++cartReadVersion;
    syncProductControls(); syncCartControls(); setText('#product-message', tr('Adicionando…'));
    let added = false;
    try {
      await request('cart/add.js', { items: [{ id, quantity }] });
      added = true; setText('#product-message', tr('Produto adicionado à sacola.'));
    } catch (error) {
      setText('#product-message', error.message);
      // A timeout or 422 can still change stock/cart; reconcile, never retry the POST.
      try { renderCart(await request('cart.js')); } catch { cartReady = false; }
    } finally {
      productBusy = false; cartBusy = false; syncProductControls(); syncCartControls();
    }
    if (added) await openCart();
  });
  $('#drawer-checkout-form')?.addEventListener('submit', event => {
    if (cartBusy || !cartReady || !currentCart?.item_count) { event.preventDefault(); setText('#checkout-message', tr('Aguarde a confirmação dos itens da sacola.')); }
  });
  function favoriteState() { $$('[data-favorite]').forEach(el => el.setAttribute('aria-pressed', String(favorites.includes(el.dataset.favorite)))); }
  const params = new URLSearchParams(location.search), grid = $('#product-grid');
  // "?max=100" limits the catalog to R$ 100 (any whole value in reais); prices are compared in cents.
  const parseMax = value => /^\d{1,6}$/.test(value || '') && Number(value) > 0 ? Number(value) * 100 : Infinity;
  let category = params.get('category') || '', max = parseMax(params.get('max')), saved = params.get('saved') === '1';
  function filter() {
    if (!grid) return;
    const cards = [...grid.querySelectorAll('[data-product]')]; let count = 0;
    cards.forEach(card => {
      const visible = (!category || normalize(card.dataset.category) === normalize(category)) && Number(card.dataset.price) <= max && (!saved || favorites.includes(card.dataset.product));
      card.hidden = !visible; if (visible) count++;
    });
    const sort = $('#sort')?.value || 'featured';
    cards.sort((a, b) => sort === 'name' ? a.dataset.name.localeCompare(b.dataset.name, 'pt-BR') : sort === 'price-asc' ? Number(a.dataset.price) - Number(b.dataset.price) : sort === 'price-desc' ? Number(b.dataset.price) - Number(a.dataset.price) : Number(a.dataset.order) - Number(b.dataset.order)).forEach(card => grid.append(card));
    setText('#result-count', `${count} ${count === 1 ? tr('produto') : tr('produtos')}${saved ? tr(' nos seus favoritos') : ''}${max !== Infinity ? trf(' · até R$ {max}', { max: max / 100 }) : ''}`);
    if ($('#no-results')) $('#no-results').hidden = count > 0;
    if ($('#clear-filters')) $('#clear-filters').hidden = !category && max === Infinity && !saved;
    $$('[data-category-filter]').forEach(el => { const active = el.dataset.categoryFilter === category; el.classList.toggle('active', active); el.setAttribute('aria-pressed', String(active)); });
  }
  grid?.querySelectorAll('[data-product]').forEach((el, index) => el.dataset.order = index);
  function commitFilters() {
    if (!grid) return;
    const url = new URL(location.href);
    for (const [key, value] of Object.entries({category, max: max !== Infinity ? String(max / 100) : '', saved: saved ? '1' : '', sort: $('#sort')?.value === 'featured' ? '' : $('#sort')?.value || ''})) {
      if (value) url.searchParams.set(key, value); else url.searchParams.delete(key);
    }
    history.replaceState({}, '', url);
    filter();
  }
  if ($('#sort') && ['featured', 'price-asc', 'price-desc', 'name'].includes(params.get('sort'))) $('#sort').value = params.get('sort');
  $('#sort')?.addEventListener('change', commitFilters);
  document.addEventListener('click', async event => {
    const el = event.target.closest('button,a'); if (!el) return;
    if (el.hasAttribute('data-combo-swap')) { event.preventDefault(); await swapCombo(); return; }
    if (el.hasAttribute('data-open-cart')) { event.preventDefault(); await openCart(); }
    else if (el.hasAttribute('data-close-cart')) closeCart();
    else if (el.hasAttribute('data-favorite')) {
      const slug = el.dataset.favorite;
      favorites = favorites.includes(slug) ? favorites.filter(value => value !== slug) : [...favorites, slug].slice(-1000);
      try { localStorage.setItem('meucompra-favorites-v1', JSON.stringify(favorites)); } catch {}
      favoriteState(); filter(); toast(favorites.includes(slug) ? tr('Salvo nos favoritos.') : tr('Removido dos favoritos.'));
    } else if (el.hasAttribute('data-category-filter')) { category = el.dataset.categoryFilter; commitFilters(); }
    else if (el.id === 'clear-filters' || el.hasAttribute('data-reset-filters')) { category = ''; max = Infinity; saved = false; commitFilters(); }
    else if (el.hasAttribute('data-quantity') && !productBusy) {
      const input = $('#quantity'); input.value = Math.max(1, Math.min(20, (Number(input.value) || 1) + Number(el.dataset.quantity)));
      updateEstimate();
    } else if (el.hasAttribute('data-gallery-src')) {
      const img = $('#detail-photo'), source = safeUrl(el.dataset.gallerySrc, true);
      if (img && source) { img.src = source; img.removeAttribute('srcset'); }
      if (el.dataset.galleryCaption) setText('#image-caption', el.dataset.galleryCaption);
      $$('[data-gallery-src]').forEach(button => button.setAttribute('aria-pressed', String(button === el)));
    } else if (el.hasAttribute('data-cart-change') || el.hasAttribute('data-remove-key')) {
      if (cartBusy || !cartReady) return;
      const key = el.dataset.cartKey || el.dataset.removeKey, item = currentCart?.items.find(line => line.key === key); if (!item) return;
      const delta = Number(el.dataset.cartChange);
      if (!el.hasAttribute('data-remove-key') && ![-1, 1].includes(delta)) return;
      const quantity = el.hasAttribute('data-remove-key') ? 0 : Math.max(0, Math.min(20, item.quantity + delta));
      cartBusy = true; ++cartReadVersion; syncCartControls(); syncProductControls();
      try { renderCart(await request('cart/change.js', { id: key, quantity })); setText('#checkout-message', ''); }
      catch (error) {
        setText('#checkout-message', error.message);
        try { renderCart(await request('cart.js')); }
        catch { cartReady = false; cartNeedsRefresh = fullCartPage; setText('#checkout-message', tr('Não foi possível confirmar a alteração. Feche e abra a sacola para conferir antes de pagar.')); }
      } finally {
        cartBusy = false; syncCartControls(); syncProductControls();
        if (cartCloseRequested) closeCart();
      }
    }
  });
  $('#cart')?.addEventListener('click', event => {
    if (event.target === $('#cart')) { const rect = $('#cart').getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeCart(); }
  });
  $('#cart')?.addEventListener('close', refreshFullCart);
  $('#cart')?.addEventListener('cancel', event => { if (fullCartPage && cartBusy) { event.preventDefault(); cartCloseRequested = true; } });
  // Without JS, the mobile action stays hidden and the native product form still works.
  const mobileBar = $('[data-mobile-buy-bar]'); if (mobileBar) { mobileBar.hidden = false; document.body.classList.add('has-mobile-buy-bar'); }
  // Search keeps native GET navigation and a keyboard-accessible clear action.
  const search = $('#search'), searchClear = $('[data-clear-search]');
  if (search && searchClear) {
    const syncSearch = () => { searchClear.hidden = !search.value; };
    search.addEventListener('input', syncSearch);
    searchClear.addEventListener('click', () => { search.value = ''; syncSearch(); search.focus(); });
    syncSearch();
  }
  // Enhance Shopify's native contact POST; native required validation remains when JS is unavailable.
  const contact = $('#ContactForm');
  if (contact) {
    contact.noValidate = true;
    const fields = [...contact.querySelectorAll('[required]')];
    fields.forEach(field => {
      const error = document.createElement('span');
      error.id = field.id + '-error'; error.className = 'field-error'; error.hidden = true;
      field.insertAdjacentElement('afterend', error);
      field.setAttribute('aria-describedby', [field.getAttribute('aria-describedby'), error.id].filter(Boolean).join(' '));
      const validate = () => {
        const invalid = !field.value.trim() || !field.validity.valid;
        error.textContent = invalid ? (field.type === 'email' ? tr('Informe um e-mail válido para receber a resposta.') : field.tagName === 'TEXTAREA' ? tr('Escreva sua mensagem.') : tr('Informe seu nome.')) : '';
        error.hidden = !invalid; field.setAttribute('aria-invalid', String(invalid)); return !invalid;
      };
      field.addEventListener('blur', validate);
      field.addEventListener('input', () => { if (field.getAttribute('aria-invalid') === 'true') validate(); });
      field.validateContact = validate;
    });
    const message = $('#contact-message');
    const expandMessage = () => { message.style.height = 'auto'; message.style.height = Math.max(150, message.scrollHeight) + 'px'; };
    message?.addEventListener('input', expandMessage);
    if (message) expandMessage();
    contact.addEventListener('submit', event => {
      const invalid = fields.filter(field => !field.validateContact());
      if (invalid.length) { event.preventDefault(); invalid[0].focus(); }
    });
  }
  favoriteState(); filter(); syncProductControls(); syncCartControls();
})();
